import { Box, Flex, Stack, desktopFirstMediaQuery } from '@inflearn/ds-react-next';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';
import useCheckMyProfile from '../../../../../hooks/useCheckMyProfile';
import useQueryParams from '../../../../../hooks/useQueryParams';
import useUserProfileQuery from '../../../../../hooks/useUserProfileQuery';
import useClientAccountProfileQuery from '../../../../../queries/useClientAccountProfileQuery';
import { formatCommaNumber } from '../../../../../utils/format/number';
import { AvatarImage } from './AvatarImage';
import { FollowingButton } from './FollowingButton';
import { HubProfile } from './HubProfile';
import { ProfileEditButton } from './ProfileEditButton';
import { RatingItem } from './RatingItem';
import { StatItem } from './StatItem';
import { UserName } from './UserName';
import { UserSlug } from './UserSlug';
import { UserSlugModal } from './UserSlugModal';

export function StudentProfile() {
  const { id } = useQueryParams();
  const { isMe } = useCheckMyProfile();
  const { data: profile } = useUserProfileQuery({ id: Number(id) });
  const { t } = useTranslation();
  const { data: myProfile } = useClientAccountProfileQuery({ enabled: isMe });
  const [isSlugModalOpened, slugModalHandler] = useDisclosure(false);

  useEffect(() => {
    if (myProfile && !myProfile.isSlugConfirmed) {
      slugModalHandler.open();
    }
  }, [myProfile]);

  if (!profile) {
    return null;
  }

  return (
    <>
      <Stack gap={24}>
        <Flex
          justify="space-between"
          styles={{
            root: {
              [desktopFirstMediaQuery.mobile]: {
                flexDirection: 'column',
                gap: 24,
              },
            },
          }}
        >
          <Flex gap={24}>
            <Box css={{ flexShrink: 0 }}>
              <AvatarImage src={profile.thumbnailUrl} />
            </Box>
            <Stack gap={10}>
              <Box>
                <UserName name={profile.name} />
                <UserSlug slug={profile.slug} />
              </Box>
            </Stack>
            <HubProfile userId={profile.id} userName={profile.name} />
          </Flex>
          <Flex gap={10}>
            {isMe && <ProfileEditButton />}
            {!isMe && <FollowingButton />}
          </Flex>
        </Flex>
        <Box
          css={{
            display: 'grid',
            width: '100%',
            gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
            gap: 12,
          }}
        >
          <StatItem
            label={t('수강평 작성수')}
            content={profile.review.count === 0 ? '-' : formatCommaNumber(profile.review.count)}
          />
          <StatItem
            label={t('평균평점')}
            content={
              profile.review.average === '0.0' ? (
                '-'
              ) : (
                <RatingItem content={profile.review.average} />
              )
            }
          />
        </Box>
      </Stack>
      {myProfile && (
        <UserSlugModal
          userId={myProfile.id}
          nickname={myProfile.name}
          thumbnailUrl={myProfile.thumbnail}
          initialSlug={myProfile.slug || ''}
          isOpened={isSlugModalOpened}
          onClose={slugModalHandler.close}
        />
      )}
    </>
  );
}
